module.exports = __webpack_public_path__ + "img/menuimg5.2a210a94.png";